module.exports = __webpack_public_path__ + "static/media/16.465b82a2.jpg";